export const CACHE_POLICY = {
	DEFAULT: {
		MAX_AGE: 31536000, // 1year
		REVALIDATED_AGE: 31536000,
	},
}

export const ACCEPTED_LANGUAGES = ['ar', 'de', 'en', 'es', 'fi', 'fr', 'iw', 'pap', 'pt', 'ru']
